var _circle, _circle2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 60.5005,
    cy: 60.6035,
    r: 60,
    fill: "url(#paint0_linear_11825_80840)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5005,
    cy: 60,
    r: 50,
    fill: "url(#paint1_linear_11825_80840)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8187 68.3582C50.8196 68.3582 50.82 68.3592 50.8194 68.3598L48.7122 70.467C48.3189 70.8603 48.3187 71.498 48.7119 71.8915L50.1064 73.287C50.4997 73.6808 51.1379 73.6809 51.5314 73.2873L74.2854 50.5333C74.6789 50.1398 74.6789 49.502 74.2854 49.1085L72.8893 47.7124C72.4959 47.3189 71.858 47.3189 71.4645 47.7124L50.8187 68.3582Z",
    fill: "#F4FBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1793 68.3582C72.1785 68.3582 72.1781 68.3592 72.1786 68.3598L74.2858 70.467C74.6792 70.8603 74.6793 71.498 74.2861 71.8915L72.8917 73.287C72.4983 73.6808 71.8602 73.6809 71.4666 73.2873L48.7126 50.5333C48.3192 50.1398 48.3192 49.502 48.7126 49.1085L50.1087 47.7124C50.5022 47.3189 51.1401 47.3189 51.5335 47.7124L72.1793 68.3582Z",
    fill: "#F4FBFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11825_80840",
    x1: 125.907,
    y1: 4.21906,
    x2: -78.0016,
    y2: 154.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910644,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11825_80840",
    x1: 90.4567,
    y1: 21.3495,
    x2: 7.37163,
    y2: 129.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.e61e0b05d2315adea2ac71c6f97a4b0d.svg";
export { ForwardRef as ReactComponent };